import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import { ThemeProvider } from "@mui/material";
import theme  from './theme';
import Checkout from './components/Checkout';
import Thanks from './components/Thanks';

export const config = {
  endpoint: `https://qkart-frontend-7vv3.onrender.com/api/v1`,
};

function App() {
  return (    
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
          
          <ThemeProvider theme={theme}>
          {/* <Register />  */}
            {/* <Login /> */}      
            <Switch>                
                <Route exact path="/login" component={Login} />
                <Route exact path="/register" component={Register} />
                <Route exact path="/checkout" component={Checkout} />
                <Route exact path="/thanks" component={Thanks} />
                <Route exact path="/" component={Products} />
            </Switch>      
          </ThemeProvider>       
    </div>
  );
}

export default App;
